const elementsToBlur = ['.page', '#hs-nav-v4', '#hs-vertical-nav', '#hs-nav-before-container #trial-banner-blocks'];
export const blurElements = blurValue => {
  elementsToBlur.forEach(selector => {
    const element = document.querySelector(selector);
    if (element) {
      element.style.filter = blurValue;
    }
  });
};